export const mba = {
  id: 'mba',
  name: 'Executive & MBA',
  sectionOrder: ['summary', 'experience', 'education', 'certifications'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['harvard-classic'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-centered'
  }
};
export default mba;
